module.exports = __webpack_public_path__ + "img/hic-pneumonia-male.8a749d68.png";